import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import { useCallback, useState } from 'react'
import { TableWithoutVirtualListingRowProps } from '../../../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import TwinIcon from '../../../../../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TableWithoutVirtualListing, { TableWithoutDefaultRowRenderer } from '../../../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import { nanoid } from 'nanoid'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { DictPaymentTypesTy, PayMCopyDateModeAddExtended } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod/types'
import { ModalFullCentered } from '../../../../../../../../baseComponents/Modal'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { InputCalendarStateFull } from '../../../../../../../../forms/Input/InputCalendar'
import { RectangularInputPrice } from '../../../../../../../../forms/Input/InputPrice'
import { CustomSelectWithSearchBar } from '../../../../../../../../forms/CustomSelect'
import NullComponent from '../../../../../../../../baseComponents/NullComponent'
import { DeleteRow } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { emptyExtraLineFirstSortFunction } from '../../../../../../../../forms/CustomSelect/functions'
import { parseManagePaymentMethodDate } from './functions'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'
import { SetEditPaymentMethodModalTy, UseEditPaymentMethodModalProps } from '../types'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import { getExactDateFromDaysFromDate, getStartOfDay } from '../../../../../../../../utils/globals/date'
import { recalculateQuantitiesModalPayM } from '../../../../../../../../utils/globals/order/paymentDates'
import { ButtonDisabledOrLoader, ButtonSecondary } from '../../../../../../../../baseComponents/Button'

interface ModalManagePaymentMethodDateProps extends ModalManagePaymentMethodDateLogicProps {}

const ModalManagePaymentMethodDate: React.FC<ModalManagePaymentMethodDateProps> = ({ openModal, setOpened, dictPaymentTypes, paymentTypesMemo, onSubmit }) => {
    const {t} = useTwinTranslation()
    const { paymentMethodDates, customRowRender, handleChangeField, deleteRow, onBlurRecalculate, handleSubmit, loading } = useModalManagePaymentMethodDateLogic({ dictPaymentTypes, paymentTypesMemo, openModal, onSubmit, setOpened })
    const lastRowIndex = paymentMethodDates && paymentMethodDates.length > 1 ? paymentMethodDates?.length - 2 : 0

    const columns: ColumnTableSchema<PayMCopyDateModeAddExtended> = [
        {
            id: 'date',
            dataKey: 'date',
            label: t('date', 'Fecha'),
            customRender: (parameterValue, allRowData) => <InputCalendarStateFull hideLabel={true} label={''} value={parameterValue} onChange={(value) => handleChangeField(allRowData.rowIndex, 'date', value)} minDate={new Date()} onlyValids={true} classNameInput='skip_margin'/>,
            className: 'overflow-visible',
            width: 120
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            customRender: (parameterValue, allRowData) => <RectangularInputPrice readOnly={allRowData.rowIndex === lastRowIndex} label={''} CurrencyId={openModal?.allRowData?.CurrencyId} onChange={(value) => handleChangeField(allRowData.rowIndex, 'quantity', value)} maxValue={openModal?.allRowData?.quantity} value={parseFloat(String(parameterValue))} onBlur={onBlurRecalculate} />,
        },
        {
            id: 'PaymentTypeId',
            dataKey: 'PaymentTypeId',
            label: t('paymentTypeN', 'Tipo de pago'),
            customRender: (parameterValue, allRowData) => <CustomSelectWithSearchBar items={paymentTypesMemo} label='' className='w-full custom_select_hide_label height_28' sortItems={true} sortFunction={emptyExtraLineFirstSortFunction} value={parameterValue} onChange={(value) => handleChangeField(allRowData.rowIndex, 'PaymentTypeId', parseInt(value))} />,
            className: 'overflow-visible w-full',
        },
        {
            id: 'id',
            dataKey: 'id',
            label: t('info', 'Información'),
            customRender: (parameterValue, allRowData) => {
                const element = dictPaymentTypes?.[paymentTypesMemo[(allRowData?.PaymentTypeId || 1)]?.relatedType as PaymentRelatedTypesKeys]
                const Component = element?.component || NullComponent
                const myValue = allRowData?.new_extra_payment_data?.id || allRowData?.new_extra_payment_data?.value || allRowData?.payment_data
                return <Component {...allRowData} {...element?.extraProps} value={myValue} onChange={(value: any) => handleChangeField(allRowData.rowIndex, 'payment_data', value)} />
            },
            className: 'overflow-visible w-full',
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + allRowData.rowIndex} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => deleteRow(allRowData.rowIndex)} />,
        }
    ]
    return (
        <ModalFullCentered className='modal_manage_payments' opened={true} setOpened={()=>setOpened(null)} onClickOut={false}>
            <h2><TwinTrans transKey='managePayment'>Gestionar pago</TwinTrans></h2>
            <div className= ' mt-20 flex flex-auto overflow-visible'>
                <TableWithoutVirtualListing data={paymentMethodDates} columns={columns} rowRenderer={customRowRender} />
            </div>
            <div className='flex items-center gap-x-10 justify-end mt-20'>
                <ButtonSecondary onClick={() => setOpened(null)}>
                    <TwinTrans transKey='cancel'>Cancelar</TwinTrans>
                </ButtonSecondary>
                <ButtonDisabledOrLoader loading={loading} buttonIsDisabled={(paymentMethodDates?.length || 0) < 2} onClick={handleSubmit} textButton={t('save', 'Guardar')} />
            </div>
        </ModalFullCentered>

    )
}
interface ModalManagePaymentMethodDateLogicProps {
    openModal: UseEditPaymentMethodModalProps
    dictPaymentTypes: DictPaymentTypesTy
    paymentTypesMemo: TwinDictionary
    setOpened: SetEditPaymentMethodModalTy
    onSubmit?: ()=>void
}

const useModalManagePaymentMethodDateLogic = ({ dictPaymentTypes, paymentTypesMemo, openModal, onSubmit, setOpened }: ModalManagePaymentMethodDateLogicProps) => {
    const [paymentMethodDates, setPaymentMethodDates] = useState<TwinDictionary[] | null>(parseManagePaymentMethodDate(openModal?.allRowData || {}))
    const { t } = useTwinTranslation()
    const completePaymentTypeErr = t('setAllPaymentTypes', 'Debes configurar todos los tipos de pago')
    const completeInfoPaymentErr = t('setAllPaymentInformation', 'Debes configurar toda la información de pago')
    const {startLoading, endLoading, loading} = useIsLoading()

    const handleSubmit = useCallback(async () => {
        startLoading()
        if (paymentMethodDates){
            const copyPaymentMethodDates = JSON.parse(JSON.stringify(paymentMethodDates))
            copyPaymentMethodDates.splice(copyPaymentMethodDates.length - 1, 1)
            for (const element of copyPaymentMethodDates) {
                if (!element.PaymentTypeId) {
                    changeErrorMessage(completePaymentTypeErr)
                    return false
                }
                const hasComponent = dictPaymentTypes?.[paymentTypesMemo[element?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys].component !== NullComponent
                if (hasComponent && !element.payment_data) {
                    changeErrorMessage(completeInfoPaymentErr)
                    return false
                }
                if (element.payment_data) {
                    element.new_extra_payment_data = { 'value': element.payment_data }
                }
                const extraProps = dictPaymentTypes?.[paymentTypesMemo[element?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys].extraProps
                if (extraProps?.items) {
                    const payment_data = extraProps?.items?.[element.payment_data]
                    element.new_extra_payment_data = {
                        iban: payment_data?.iban,
                        name: payment_data?.name,
                        id: payment_data?.id,
                    }
                }
                element.date = getStartOfDay(element.date)
                element.PayMCopyId = openModal?.allRowData.PayMCopyId
                element.CurrencyId = openModal?.allRowData.CurrencyId
                delete element.id
            }
            const result = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/managePaymentMethodCopyDates', { oldId: openModal?.allRowData?.id, newPayMCopyDates: copyPaymentMethodDates })
            if(result){
                setOpened(null)
                onSubmit?.()
            }
        }
        endLoading()
    }, [paymentMethodDates, completeInfoPaymentErr, dictPaymentTypes, paymentTypesMemo, openModal?.allRowData?.CurrencyId, openModal?.allRowData.PayMCopyId, completePaymentTypeErr, openModal?.allRowData?.id, onSubmit, setOpened, startLoading, endLoading])

    const handleChangeField = useCallback((pos: number, field: string, value: any) => {
        setPaymentMethodDates((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (copy) {
                copy[pos][field] = value
                if (field === 'PaymentTypeId') {
                    const paymentTypeData = dictPaymentTypes?.[paymentTypesMemo[value]?.relatedType as PaymentRelatedTypesKeys]
                    copy[pos].payment_data = paymentTypeData?.extraProps?.value
                }
            }
            return copy
        })
    }, [setPaymentMethodDates, paymentTypesMemo, dictPaymentTypes])

    const deleteRow = useCallback((rowIndex: number) => {
        setPaymentMethodDates((old) => {
            if (!old) {
                return old
            }
            const copy = JSON.parse(JSON.stringify(old))
            copy.splice(rowIndex, 1)
            recalculateQuantitiesModalPayM(openModal?.allRowData?.quantity || 0, copy)
            return copy
        })
    }, [setPaymentMethodDates, openModal?.allRowData?.quantity])

    const addRow = useCallback(() => {
        setPaymentMethodDates((old) => {
            if (!old) {
                return old
            }
            const lastOne = old.length > 1 ? old[old.length - 2] : null
            const copy = JSON.parse(JSON.stringify(old))
            copy.splice(copy.length - 1, 0, { subId: nanoid(), date: getExactDateFromDaysFromDate(30, lastOne?.date) })
            recalculateQuantitiesModalPayM(openModal?.allRowData?.quantity || 0, copy)
            return copy
        })
    }, [setPaymentMethodDates, openModal?.allRowData?.quantity])

    const customRowRender = useCallback((props: TableWithoutVirtualListingRowProps) => {
        if (props.rowData.subId === 'addButton') {
            return (
                <div className='cursor-pointer text-center bg-gray-EF py-8 w-full text-gray-51 ' onClick={addRow}>
                    <TwinIcon className='mr-10' icon={faPlus} />
                    <TwinTrans transKey='addRow'>Añadir fila</TwinTrans>
                </div>
            )
        }
        return <TableWithoutDefaultRowRenderer {...props} key={props.rowData?.subId || props.rowData?.id} className='overflow-visible h-48' />
    }, [addRow])

    const onBlurRecalculate = useCallback(() => {
        setPaymentMethodDates((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (copy) {
                recalculateQuantitiesModalPayM(parseFloat(String(openModal?.allRowData?.quantity)), copy)
            }
            return copy
        })
    }, [setPaymentMethodDates, openModal?.allRowData?.quantity])

    return { paymentMethodDates, customRowRender, deleteRow, handleChangeField, onBlurRecalculate, handleSubmit, loading }
}


export default ModalManagePaymentMethodDate